import { IImageAsset } from '../contentful';
import { getResponsiveContentfulImageUrl } from '../ui';

export function getCardIcon(image?: IImageAsset) {
	if (!image) {
		return undefined;
	}

	const { url } = image.fields.file;

	return getResponsiveContentfulImageUrl(url, {});
}
